import React from 'react';  
import { Route,Routes,useLocation,useNavigate } from 'react-router-dom';  
/*import {
	TransitionGroup,
	CSSTransition
  } from "react-transition-group";*/

/** Custom CSS */
import './App.css';  

/** Custom Components */
import ChangePasswordComponent from './pages/changepassword';
import MainComponent from './pages/main-page';
import UploadDFGComponent from './pages/upload-dfg';
import HomeComponent from './pages/home';
import DocumentListComponent from './pages/documentlist';
import AddMenuComponent from './pages/addmenu';
import DemandComponent from './pages/demand';
import ViewComponent from './pages/view-document';
import LoginComponent from './pages/login';
import PageComponent from './pages/page';
import AppropriationComponent from './pages/appropriation';
import ErrorComponent from './pages/error';
import RevisedDemandComponent from './pages/reviseddemand';
import RevisedAppropriationComponent from './pages/revisedappropriation';

function App() {  
	let location = useLocation();

	return (  
		<main className='root'>
			<Routes location={location}>
				<Route path="*" element={<ErrorComponent/>} exact />
				<Route path="/" element={<MainComponent/>} exact />
				<Route path="/main" element={<MainComponent/>} exact />

				<Route path="/login" element={<LoginComponent history={useNavigate()} />} />
				<Route path="/home" element={<HomeComponent history={useNavigate()} />} />
				<Route path="/documentlist" element={<DocumentListComponent history={useNavigate()} />} />
				<Route path="/uploaddfg" element={<UploadDFGComponent history={useNavigate()} />} />
				<Route path="/uploadreviseddfg" element={<UploadDFGComponent history={useNavigate()} />} />
				<Route path="/changepwd" element={<ChangePasswordComponent history={useNavigate()} />} />
				<Route path="/addmenu" element={<AddMenuComponent history={useNavigate()} />} />

				<Route path="/demand" element={<DemandComponent/>} />
				<Route path="/reviseddemand" element={<RevisedDemandComponent/>} />
				<Route path="/demand/:id" element={<AppropriationComponent/>} />
				<Route path="/reviseddemand/:id" element={<RevisedAppropriationComponent/>} />
				<Route path="/page/:id" element={<PageComponent/>} />
				<Route path="/view/:finyear/:link" element={<ViewComponent />} />
				<Route path="/error" element={<ErrorComponent/>} />
			</Routes>

        </main>
	);  
}  
  
export default App; 